import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import logoCoordiPH from "../../assets/coordi_ph_logo_letras_2.png";

// "Enviar correo evento" del pase, igual que en la app (detalle_pase.dart → _enviarCorreo):
// se arma la imagen del pase como la captura la app al compartir (logo, copropiedad, fecha y
// hora si es TEMPORAL y el código QR con el id), se sube a Storage en pases/ y el backend
// manda el correo con esa imagen al visitante, con copia a quien lo envía.

const URL_CORREO_PASE = "https://coordiph.herokuapp.com/pases/enviarcorreo";
const ASUNTO_PASE = "¡Tu pase de acceso ya está listo!";

export const ROLES_ENVIO_PASE = ["RESIDENTE", "ADMINISTRADOR", "SUPER"];

const texto = (valor) => String(valor ?? "").toUpperCase();

const datoColumna = (etiqueta, valor) => `
  <div style="text-align:center;">
    <div style="font-weight:bold;font-size:14px;">${etiqueta}</div>
    <div style="font-size:14px;margin-top:8px;">${valor}</div>
  </div>`;

const armarTarjetaPase = async (pase) => {
  const qr = await QRCode.toDataURL(String(pase.id), { margin: 0, width: 260 });
  const temporal = pase.tipoPermiso === "TEMPORAL"
    ? `<div style="display:flex;justify-content:center;gap:40px;margin-top:8px;">
        ${datoColumna("FECHA:", texto(pase.fechaTemporalPermiso))}
        ${datoColumna("HORA:", texto(pase.horaTemporalPermiso || "No aplica"))}
      </div>`
    : "";

  const tarjeta = document.createElement("div");
  tarjeta.style.cssText =
    "position:fixed;left:-10000px;top:0;width:360px;padding:16px;background:#ffffff;" +
    "color:#000000;font-family:Arial,Helvetica,sans-serif;border-radius:4px;";
  tarjeta.innerHTML = `
    <div style="text-align:center;margin:8px 0;"><img src="${logoCoordiPH}" style="height:120px;" alt=""></div>
    <div style="margin-top:10px;">${datoColumna("COPROPIEDAD:", texto(pase.nombreCliente))}</div>
    ${temporal}
    <hr style="border:0;border-top:1px solid #000000;margin:10px 0;">
    <div style="text-align:center;padding:20px;"><img src="${qr}" style="width:260px;height:260px;" alt=""></div>`;

  document.body.appendChild(tarjeta);
  await Promise.all(Array.from(tarjeta.querySelectorAll("img")).map((img) =>
    img.complete ? null : new Promise((listo) => { img.onload = listo; img.onerror = listo; })
  ));
  return tarjeta;
};

const subirImagenPase = async (pase) => {
  const tarjeta = await armarTarjetaPase(pase);
  try {
    const canvas = await html2canvas(tarjeta, { scale: 2, backgroundColor: "#ffffff" });
    const imagen = await new Promise((listo) => canvas.toBlob(listo, "image/jpeg", 0.92));
    return await subirArchivoFirebase(`pases/${pase.id} - ${new Date().toISOString()}.jpeg`, imagen);
  } finally {
    tarjeta.remove();
  }
};

export const enviarPasePorCorreo = async (pase) => {
  const { value: correo } = await Swal.fire({
    title: "Enviar invitación",
    input: "email",
    inputLabel: "Correo electrónico",
    inputPlaceholder: "ejemplo@correo.com",
    inputValue: pase.correoElectronico && pase.correoElectronico !== "null" ? pase.correoElectronico : "",
    validationMessage: "Escriba un correo válido",
    showCancelButton: true,
    confirmButtonText: "Si",
    cancelButtonText: "No",
  });
  if (!correo) return;

  Swal.fire({ title: "Enviando correo...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });
  try {
    const urlPase = await subirImagenPase(pase);
    const respuesta = await fetch(URL_CORREO_PASE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        correoElectronico: correo,
        urlPase,
        copiaCorreo: localStorage.getItem("CorreoElectronico") || "",
        asuntoCorreo: ASUNTO_PASE,
      }),
    });
    if (!respuesta.ok) throw new Error(`El backend respondió ${respuesta.status}`);
    Swal.fire({ icon: "success", title: "¡Notificación enviada!", timer: 2000, showConfirmButton: false });
  } catch (error) {
    console.error("No se pudo enviar el pase por correo:", error);
    Swal.fire("Error", "No se pudo enviar el correo del pase. Intente de nuevo.", "error");
  }
};
